// src/components/SequenceOverview/ContactList/ContactListCard.jsx
import React from 'react';
import { Checkbox } from 'antd';
import { cn } from '../../../../../helper/cn';
import { ICONS } from '../../../../../assets/icons';

const STATUS_STYLES = {
  TRIGGERED: { color: '#9747FF', bg: '#F7F1FF', icon: ICONS.SequenceTriggered },
  COMPLETED: { color: '#00D998', bg: '#EBFCF7', icon: ICONS.SequenceCompleted },
  PAUSED:    { color: '#FB6E42', bg: '#FB6E4214', icon: ICONS.PausedOrange },
  FAILED:    { color: '#FF543E', bg: '#FFF2F0', icon: ICONS.SequenceFailed },
  ACTIVE:    { color: '#1778F2', bg: '#EDF5FE', icon: ICONS.SequenceActive },
  ABANDONED: { color: '#F6A723', bg: '#FFF8EE', icon: ICONS.SequenceAbandoned },
};

const ContactListCard = ({ data, isSelected, onToggle, trStyle }) => {
  const formatTime = iso => {
    if (!iso) return '-';
    return new Date(iso).toLocaleString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };

  const style = STATUS_STYLES[data.status] || {};

  return (
    <>
      <div className={cn('w-[4%]', trStyle)}>
        <Checkbox checked={isSelected} onChange={onToggle} />
      </div>
      <div className={cn('w-[30%]', trStyle)}>{data.profile_name || '-'}</div>
      <div className={cn('w-[25%]', trStyle)}>{data?.phone_country_code ? (`(+${data?.phone_country_code}) ${data?.phone_number}`) : data?.phone_number || '-'}</div>
      <div className={cn('w-[25%]', trStyle)}>{formatTime(data.created_at)}</div>
      <div className={cn('w-[20%] flex items-center', trStyle)}>
        <div
          className="px-2.5 py-1 rounded-md flex items-center gap-1.5"
          style={{
            backgroundColor: style.bg,
            color: style.color,
            border: `1.5px solid ${style.color}`,
          }}
        >
          {style.icon && <img src={style.icon} alt={data.status} className="w-3 h-3" />}
          <span className="text-xs">{data.status}</span>
        </div>
      </div>
    </>
  );
};

export default ContactListCard;
